export default __webpack_public_path__ + "static/media/edit.9478abc7.svg";